import { LOCAL_STORAGE_VARIABLES } from '../constants/constants';

export const getToken = () => {
  const token = localStorage.getItem(LOCAL_STORAGE_VARIABLES.JWT);
  if (token) return `Bearer ${token}`;
  return '';
};
